// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import isDev from 'utils/env'
import { range } from 'lodash'
import FormItemLabel from 'antd/lib/form/FormItemLabel'
import { string } from 'prop-types'

export interface IOption {
  label: string
  value: string
}
export interface IField {
  name: string
  key: string
  type: string
  options?: IOption[]
}

const ReCaptureMaxCountRange = range(1, 256).map(item => ({ label: item, value: item }))

export const ImageQualityFields: IField[] = [
  { name: 'rephotographFlag', key: 'rephotographFlag', type: 'switch' },
  { name: 'deleteImageFlag', key: 'deleteImageFlag', type: 'switch' },
  { name: 'reCaptureConfigBlurredFlag', key: 'reCaptureConfigBlurredFlag', type: 'switch' },
  { name: 'reCaptureConfigCorruptFlag', key: 'reCaptureConfigCorruptFlag', type: 'switch' },
  { name: 'reCaptureConfigNormalFlag', key: 'reCaptureConfigNormalFlag', type: 'switch' },
  { name: 'reCaptureConfigOverExposedFlag', key: 'reCaptureConfigOverExposedFlag', type: 'switch' },
  { name: 'reCaptureConfigUnderExposedFlag', key: 'reCaptureConfigUnderExposedFlag', type: 'switch' },
  { name: 'reCaptureMaxCount', key: 'reCaptureMaxCount', type: 'select', options: ReCaptureMaxCountRange }
]
export const PrivacyFields: IField[] = [{ name: 'indoorDeleteFlag', key: 'indoorDeleteFlag', type: 'switch' }]
export const SupportedAIModels = [
  { name: 'Image Quality', key: 'aiImageQuality', children: ImageQualityFields },
  { name: 'Privacy', key: 'aiPrivacy', children: PrivacyFields }
  //{ name: 'Scene', key: 'aiScene' },
  //{ name: 'POI', key: 'aiPoi' },
  //{ name: 'Traffic Sign', key: 'aiTrafficSign' },
  //{ name: 'Privacy', key: 'aiPrivacy' }
]
const MonitorDashboardUrlStaging = 'http://10.204.97.85/dashboards'
const MonitorDashboardUrlProduction = 'http://10.204.112.55:3000/'
// const MonitorDashboardUrlProduction = 'http://10.204.112.102:3000/'
export const MonitorDashboradUrl = isDev() ? MonitorDashboardUrlStaging : MonitorDashboardUrlProduction
